module.exports = __webpack_public_path__ + "assets/img/guolu.d126e771.png";